import axiosClient from "./axiosClient";

async function descargarArchivo(ruta, params, nombreArchivo, tipoMime) {
  const response = await axiosClient.get(ruta, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: tipoMime }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", nombreArchivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

const descargarPdf = (ruta, params, nombreArchivo) => descargarArchivo(ruta, params, nombreArchivo, "application/pdf");
const descargarExcel = (ruta, params, nombreArchivo) =>
  descargarArchivo(ruta, params, nombreArchivo, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

export const descargarResumenMensualPdf = (cuentaId, mes, anio) =>
  descargarPdf("/reportes/resumen-mensual", { cuentaId, mes, anio }, `ResumenMensual_${mes}_${anio}.pdf`);

export const descargarGastosFijosMesPdf = (cuentaId, mes, anio) =>
  descargarPdf("/reportes/gastos-fijos-mes", { cuentaId, mes, anio }, `GastosFijos_${mes}_${anio}.pdf`);

export const descargarAnualPdf = (cuentaId, anio) =>
  descargarPdf("/reportes/anual", { cuentaId, anio }, `ConsolidadoAnual_${anio}.pdf`);

export const descargarAdminPdf = (mes, anio) =>
  descargarPdf("/reportes/admin", { mes, anio }, `ReporteGlobalAdmin_${mes}_${anio}.pdf`);

export const descargarFamiliaGastosPdf = () =>
  descargarPdf("/reportes/familia-gastos", {}, "FamiliaGastos.pdf");

export const descargarCobrosFamiliaPdf = (mes, anio) =>
  descargarPdf("/reportes/cobros-familia", { mes, anio }, `CobrosFamilia_${mes}_${anio}.pdf`);

export const descargarHistoricoIngresosExcel = (cuentaId, desde, hasta) =>
  descargarExcel("/reportes/historico-ingresos-excel", { cuentaId, desde, hasta }, `HistoricoIngresos_${cuentaId}.xlsx`);

export const descargarHistoricoGastosExcel = (cuentaId, desde, hasta) =>
  descargarExcel("/reportes/historico-gastos-excel", { cuentaId, desde, hasta }, `HistoricoGastos_${cuentaId}.xlsx`);
